import { useMutation } from '@tanstack/react-query';
import supabaseClient from './supabaseClient';

const useDeleteAccount = () => {
  return useMutation({
    mutationFn: async () => {
      // Get the current session for the auth token
      const {
        data: { session },
      } = await supabaseClient.auth.getSession();

      if (!session) {
        throw new Error('No active session');
      }

      // Call the Edge Function to delete the account
      const { data, error } = await supabaseClient.functions.invoke('delete_account', {
        headers: {
          Authorization: `Bearer ${session.access_token}`,
        },
      });

      if (error) {
        throw new Error(error.message || 'Failed to delete account');
      }

      if (data?.error) {
        throw new Error(data.error);
      }

      // Sign out the user after successful deletion
      await supabaseClient.auth.signOut();

      return data;
    },
  });
};

export default useDeleteAccount;
